<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div class="fill-height">
        <md-table
          v-model="assignments"
          md-sort="name"
          md-sort-order="asc"
          @md-selected="view"
          md-card
          md-fixed-header
        >
          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <h1 class="md-title">Assignments</h1>
            </div>

            <div class="md-toolbar-section-end">
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-field md-clearable>
                    <md-input placeholder="Search by name..." v-model="filter" @input="doFilter" />
                  </md-field>
                </div>
                <div class="md-layout-item md-size-15" style="text-align: right">
                  <md-button @click="addAssignment" class="md-raised md-primary">Add</md-button>
                </div>
              </div>
            </div>
          </md-table-toolbar>

          <md-table-empty-state
            md-label="No Assignments found"
            :md-description="`No assignments found for this '${filter}' query. Try a different search term or create a new assignment.`"
          >
            <md-button class="md-primary md-raised" @click="addAssignment">Create New Assignment</md-button>
          </md-table-empty-state>

          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
            <md-table-cell>
              <md-avatar>
                <img :src="item.avatar" :alt="item | name" />
              </md-avatar>
            </md-table-cell>
            <md-table-cell md-label="Name" md-sort-by="title">{{ item | name }}</md-table-cell>
            <md-table-cell
              md-label="Assignment Date"
              md-sort-by="assignment_date"
            >{{ item.assignment_date | formatDate }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "AssignmentList",
  props: {
    assignments: Array,
    detailLink: String
  },
  methods: {
    addAssignment: function() {
      this.$emit("add");
    },
    doFilter: function() {
      this.$emit("filter", this.filter);
    },
    view: function(assignment) {
      this.$router.push(`${this.detailLink}/${assignment.assignment_id}`);
    }
  },
  data: function() {
    return {
      showFilter: false,
      filter: undefined
    };
  },
  filters: {
    count: function(value) {
      if (value) return value.length;
      else return 0;
    },
    name: function(value) {
      if (value) return value.first_name + " " + value.last_name;
      else "";
    },
    formatDate: function(value) {
      if (value) return moment(value).format("MMM DD, YYYY");
      else return "";
    }
  }
};
</script>
<style lang="scss" scoped>
.serie-card {
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.serie-info-card {
  width: 125px;
  display: inline-block;
  vertical-align: top;
}
.serie-info-header {
  margin-top: 0px;
  text-align: center;
}
.serie-info-content {
  text-align: center;
}
.fill-height {
  height: calc(100vh - 250px);
}
.md-list {
  width: 640px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}
.section-list-app {
  width: 640px;
  margin-right: auto;
  margin-left: auto;
}
.section-list-content {
  padding: 0px;
}
.toolbar-search {
  margin-top: -2px !important;
}
</style>
